import {IconButton, Popper} from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import OTPLoginForm from "../../auth/OTPLoginForm";

interface LoginButtonProps {
    buttonTextStyle: any
    iconStyle: any
}

const ManageControl = (props: LoginButtonProps) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    // const isAuthenticated = useSelector((state: any) => state.auth.isAuthenticated);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'login-popper' : undefined;

    return (
        <div>
            <IconButton
                edge="start"
                color="inherit"
                aria-label="sign-in"
                onClick={handleClick}
            >
                <ManageHistoryIcon sx={props.iconStyle}/>
                <h5 style={props.buttonTextStyle}>Manage</h5>
            </IconButton>
            <Popper id={id} open={open} anchorEl={anchorEl} sx={{ zIndex:101}}>
                <Box sx={{border: 2, p: 2, m: 2,  bgcolor: '#dddddd'}}>
                    <OTPLoginForm paperHeight={350} handleClose={handleClick}/>
                </Box>
            </Popper>
        </div>
    );
}

export default ManageControl
